import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT_PHONE, CONTACT_PHONE_HREF } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function FinalCTA() {
  const r = useReveal();
  return (
    <section className="relative overflow-hidden py-24 md:py-32" style={{ background: "var(--ls-orange)" }}>
      <div
        className="pointer-events-none absolute inset-0 opacity-10"
        style={{ backgroundImage: "radial-gradient(rgba(0,0,0,0.5) 1px, transparent 1px)", backgroundSize: "6px 6px" }}
      />
      <div ref={r.ref} className={`max-w-4xl mx-auto px-5 md:px-8 text-center relative ${r.className}`}>
        <h2 className="font-display text-[#1a0f06] text-[11vw] sm:text-6xl md:text-7xl">
          Stop missing leads. Start booking jobs.
        </h2>
        <p className="mt-5 text-[#3a2410] text-lg font-semibold">
          Website built for free. $597/mo. Cancel anytime.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a
            href={CONTACT_PHONE_HREF}
            className="inline-flex items-center gap-2 bg-[#0a0f16] text-white font-cond font-bold uppercase tracking-wide px-7 py-3.5 rounded-[4px] transition-transform hover:-translate-y-0.5"
          >
            <Phone className="w-4 h-4" /> Call {CONTACT_PHONE}
          </a>
          <Link
            to="/#cta"
            className="inline-flex items-center gap-2 border border-[#1a0f06] text-[#1a0f06] font-cond font-bold uppercase tracking-wide px-7 py-3.5 rounded-[4px] transition-colors hover:bg-[#1a0f06]/10"
          >
            Get More Jobs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
